<div class="main-section">
    <div class="image-background"></div>
    <div class="form-container">
        <h2>{{'CP_SM_SELECT_COUNTRY_MAIN_HEADER' | translate}} </h2>
        <p>
            {{'CP_SM_COUNTRY_CONFIRMATION_SUBMESSAGE' | translate}}
        </p>

            <div data-on="contrast" class="country-dropdown-region">
                <div style="width: min(90vw, 20rem)">
                    <wb-combobox size="m" (wbcomboboxlistselectionchange)="selectCountry($event)" (wbcomboboxinput)="showCountryList = true">
                        <wb-combobox-input data-testid="wb-combobox-input" slot="input" error="{{isSelectedCountrySupported}}" >
                            <span slot="label" style="display: flex;">{{'CP_SM_COUNTRY_LBL' | translate}}</span>
                        </wb-combobox-input>
                        <wb-combobox-list data-testid="wb-combobox-list" no-items-found-text="No countries found" list-behaviour="inline" *ngIf="showCountryList">
                            <ng-container *ngFor="let country of countryList">
                                <wb-combobox-list-item >{{country.title}}</wb-combobox-list-item>
                            </ng-container>
                        </wb-combobox-list>
                        <ng-container *ngIf="isSelectedCountrySupported">
                                <wb-control-error slot="message">
          {{'CP_SM_UNSUPPORTED_COUNTRY_ERROR_MSG' | translate}}
        </wb-control-error>
                        </ng-container>
                    </wb-combobox>
                </div>
            </div>
    </div>
    <div class="footer-section">
        <div class="checkbox-region">
            <wb-checkbox name="newsletter" (wbchange)="onCheckBoxSelect($event)">
                <p class="confirmation-lbl">{{'CP_SM_COUNTRY_CONFIRMATION_CHECKBOX_LBL' | translate }}
                </p>
                <input aria-hidden="true" type="checkbox" name="newsletter" value="on" style="display: none;"
                    id="eventsTermsCheckbox" #eventsTermsCheckbox />
            </wb-checkbox>
        </div>
        <div class="button-select-region">
            <wb-button variant="primary" size="l" class="confirm_btn button-primary" (click)="onCountrySelectClick()" [disabled]="!hasUserConfirmedCountry || userOriginCountry=== '' || !userOriginCountry || isLoginRedirectionInProgress">
                <span>{{'CP_SM_CONTINUE_BTN_LBL' | translate}} </span>
                <span *ngIf="isLoginRedirectionInProgress" class="wbx-spinner spinner"></span>
            </wb-button>
        </div>
    </div>
</div>